/**
 * HRC facets: .hrc-filter-block.is-open accordion (facets.css).
 * Varsayılan tüm kırılımlarda kapalı; başlığa tıklayınca aç/kapa.
 * Filtre navigasyonunda scroll pozisyonunu korur.
 */
(function () {
  const SCROLL_KEY = "hrcFacetScrollY";

  function saveFacetScroll() {
    try {
      const y = window.scrollY || window.pageYOffset || 0;
      sessionStorage.setItem(SCROLL_KEY, String(Math.round(y)));
    } catch {
      /* ignore */
    }
  }

  function restoreFacetScroll() {
    let y = null;
    try {
      const raw = sessionStorage.getItem(SCROLL_KEY);
      if (raw == null) return;
      sessionStorage.removeItem(SCROLL_KEY);
      y = parseInt(raw, 10);
    } catch {
      return;
    }
    if (!Number.isFinite(y) || y < 0) return;

    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    const html = document.documentElement;
    const prevBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";

    const apply = () => {
      window.scrollTo(0, y);
    };

    apply();
    requestAnimationFrame(apply);
    window.addEventListener(
      "load",
      () => {
        apply();
        html.style.scrollBehavior = prevBehavior;
        if ("scrollRestoration" in history) {
          history.scrollRestoration = "auto";
        }
      },
      { once: true },
    );
  }

  // Facet navigasyonunda scroll pozisyonunu korumak için paylaşılan API
  window.hrcFacetScroll = {
    save: saveFacetScroll,
    restore: restoreFacetScroll,
  };

  let facetNavQueued = false;

  function hideFacetLoading() {
    const overlay = document.getElementById("hrc-facet-loading");
    const main = document.querySelector(".hrc-collection-main");
    const wrapper = document.querySelector(".hrc-collection-wrapper");
    const container = document.getElementById("ProductGridContainer");

    if (overlay) {
      overlay.classList.remove("is-active");
      overlay.hidden = true;
      overlay.setAttribute("aria-hidden", "true");
      overlay.setAttribute("aria-busy", "false");
    }
    if (container) container.removeAttribute("aria-busy");
    if (main) main.classList.remove("is-filtering");
    if (wrapper) wrapper.classList.remove("is-filtering");
    facetNavQueued = false;
  }

  function showFacetLoading() {
    const overlay = document.getElementById("hrc-facet-loading");
    const main = document.querySelector(".hrc-collection-main");
    const wrapper = document.querySelector(".hrc-collection-wrapper");
    const container = document.getElementById("ProductGridContainer");

    if (overlay) {
      overlay.hidden = false;
      overlay.classList.add("is-active");
      overlay.setAttribute("aria-hidden", "false");
      overlay.setAttribute("aria-busy", "true");
      // Force paint so loader is visible before navigation
      void overlay.offsetWidth;
    }
    if (container) container.setAttribute("aria-busy", "true");
    if (main) main.classList.add("is-filtering");
    if (wrapper) wrapper.classList.add("is-filtering");
  }

  /**
   * Show loader, let the browser paint, then navigate.
   * Without this, fast (cached) filter loads skip the paint entirely.
   */
  function queueFacetNavigation(navigateFn) {
    if (facetNavQueued) return;
    facetNavQueued = true;
    saveFacetScroll();
    showFacetLoading();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try {
          navigateFn();
        } catch {
          hideFacetLoading();
        }
      });
    });
  }

  window.hrcFacetLoading = {
    show: showFacetLoading,
    hide: hideFacetLoading,
    queue: queueFacetNavigation,
  };

  window.addEventListener("pageshow", function (event) {
    // bfcache restore must clear locked pointer-events / stuck overlay
    if (event.persisted) hideFacetLoading();
  });

  function applyDefaultOpenState(sidebar) {
    sidebar.querySelectorAll(".hrc-filter-block").forEach((block) => {
      block.classList.remove("is-open");
    });
  }

  function syncHeadersAria(sidebar) {
    sidebar.querySelectorAll(".hrc-filter-block").forEach((block) => {
      const header = block.querySelector(".hrc-filter-header");
      if (!header) return;
      header.setAttribute(
        "aria-expanded",
        block.classList.contains("is-open") ? "true" : "false",
      );
    });
  }

  function bindFilterAccordions(root) {
    const sidebar = root.querySelector(".hrc-sidebar-filters");
    if (!sidebar) return;

    applyDefaultOpenState(sidebar);

    sidebar.querySelectorAll(".hrc-filter-block").forEach((block) => {
      const header = block.querySelector(".hrc-filter-header");
      if (!header || header.dataset.hrcAccordionBound === "true") return;
      header.dataset.hrcAccordionBound = "true";

      header.setAttribute("role", "button");
      if (!header.hasAttribute("tabindex"))
        header.setAttribute("tabindex", "0");
      header.setAttribute(
        "aria-expanded",
        block.classList.contains("is-open") ? "true" : "false",
      );

      const syncAria = () => {
        header.setAttribute(
          "aria-expanded",
          block.classList.contains("is-open") ? "true" : "false",
        );
      };

      header.addEventListener("click", (event) => {
        if (event.target.closest(".hrc-filter-reset")) return;
        event.preventDefault();
        block.classList.toggle("is-open");
        syncAria();
      });

      header.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (event.target.closest(".hrc-filter-reset")) return;
        event.preventDefault();
        block.classList.toggle("is-open");
        syncAria();
      });
    });
  }

  function isFiltersDrawerOpen() {
    return document.body.classList.contains("hrc-filters-drawer-open");
  }

  function preparePriceInputs(form) {
    if (!form) return;
    form
      .querySelectorAll(".hrc-price-inputs input[type='number'][data-hrc-price-param]")
      .forEach((input) => {
        const param = input.getAttribute("data-hrc-price-param");
        input.removeAttribute("name");
        if (!param) return;
        const raw = (input.value || "").trim().replace(",", ".");
        if (raw === "") return;
        const major = parseFloat(raw, 10);
        if (!Number.isFinite(major)) return;
        input.name = param;
        input.value = String(Math.round(major * 100));
      });
  }

  function applyDrawerFilters(form) {
    if (!form) return;
    preparePriceInputs(form);
    queueFacetNavigation(function () {
      form.submit();
    });
  }

  function snapshotFilterInputs(drawer) {
    const inputs = drawer.querySelectorAll(
      ".hrc-sidebar-filters input, .hrc-sidebar-filters select, .hrc-sidebar-filters textarea",
    );
    return Array.from(inputs).map((el) => ({
      el,
      checked: el.checked,
      value: el.value,
    }));
  }

  function restoreFilterInputs(snapshot) {
    if (!snapshot) return;
    snapshot.forEach((item) => {
      if (!item.el) return;
      if (item.el.type === "checkbox" || item.el.type === "radio") {
        item.el.checked = item.checked;
      } else {
        item.el.value = item.value;
      }
    });
  }

  function bindFiltersDrawer(root) {
    const scope = root || document;
    const mq = window.matchMedia("(max-width: 989px)");

    scope.querySelectorAll("[data-hrc-filters-drawer]").forEach((drawer) => {
      if (drawer.dataset.hrcFiltersDrawerBound === "true") return;
      drawer.dataset.hrcFiltersDrawerBound = "true";

      const form = drawer.closest("form");
      const wrapper = drawer.closest("facet-filters-form") || scope;
      const openBtns = wrapper.querySelectorAll("[data-hrc-filters-open]");
      const panel = drawer.querySelector(".hrc-filters-drawer__panel");
      const applyBtn = drawer.querySelector("[data-hrc-filters-apply]");
      if (!panel) return;

      let snapshot = null;
      let lastFocus = null;
      let scrollY = 0;

      const focusableSelector = [
        "a[href]",
        "button:not([disabled])",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        '[tabindex]:not([tabindex="-1"])',
      ].join(", ");

      function getFocusable() {
        return Array.from(panel.querySelectorAll(focusableSelector)).filter(
          (el) => el.offsetParent !== null || el === document.activeElement,
        );
      }

      function lockBody() {
        scrollY = window.scrollY || window.pageYOffset || 0;
        document.body.classList.add("hrc-filters-drawer-open");
        document.body.style.top = "-" + scrollY + "px";
      }

      function unlockBody() {
        document.body.classList.remove("hrc-filters-drawer-open");
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      }

      function setOpenUi(open) {
        drawer.classList.toggle("is-open", open);
        openBtns.forEach((btn) => {
          btn.setAttribute("aria-expanded", open ? "true" : "false");
        });
        if (open) {
          panel.setAttribute("role", "dialog");
          panel.setAttribute("aria-modal", "true");
          panel.setAttribute("aria-hidden", "false");
          if ("inert" in panel) panel.inert = false;
        } else {
          panel.removeAttribute("role");
          panel.removeAttribute("aria-modal");
          if (mq.matches) panel.setAttribute("aria-hidden", "true");
          else panel.removeAttribute("aria-hidden");
          if ("inert" in panel) panel.inert = mq.matches;
        }
      }

      function openDrawer() {
        if (!mq.matches || drawer.classList.contains("is-open")) return;
        snapshot = snapshotFilterInputs(drawer);
        lastFocus = document.activeElement;
        setOpenUi(true);
        lockBody();

        drawer.querySelectorAll(".hrc-filter-block").forEach((block) => {
          const checked = block.querySelector(".hrc-checkbox-input:checked");
          const priceFilled = Array.from(
            block.querySelectorAll(".hrc-price-field input"),
          ).some((input) => (input.value || "").trim() !== "");
          if (checked || priceFilled) {
            block.classList.add("is-open");
            const header = block.querySelector(".hrc-filter-header");
            if (header) header.setAttribute("aria-expanded", "true");
          }
        });

        const closeBtn = panel.querySelector(".hrc-filters-drawer__close");
        requestAnimationFrame(() => {
          (closeBtn || getFocusable()[0] || panel).focus?.();
        });
      }

      function closeDrawer(restore) {
        if (!drawer.classList.contains("is-open")) {
          setOpenUi(false);
          return;
        }
        if (restore) restoreFilterInputs(snapshot);
        snapshot = null;
        setOpenUi(false);
        unlockBody();
        if (lastFocus && typeof lastFocus.focus === "function") {
          lastFocus.focus();
        }
        lastFocus = null;
      }

      openBtns.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          openDrawer();
        });
      });

      drawer.querySelectorAll("[data-hrc-filters-close]").forEach((el) => {
        el.addEventListener("click", (event) => {
          event.preventDefault();
          closeDrawer(true);
        });
      });

      if (applyBtn) {
        applyBtn.addEventListener("click", (event) => {
          event.preventDefault();
          applyDrawerFilters(form);
        });
      }

      panel.addEventListener("keydown", (event) => {
        if (!drawer.classList.contains("is-open")) return;
        if (event.key === "Escape") {
          event.preventDefault();
          closeDrawer(true);
          return;
        }
        if (event.key !== "Tab") return;
        const nodes = getFocusable();
        if (!nodes.length) return;
        const first = nodes[0];
        const last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      const onMq = (event) => {
        if (!event.matches) closeDrawer(true);
        else if (!drawer.classList.contains("is-open")) setOpenUi(false);
      };
      if (typeof mq.addEventListener === "function") mq.addEventListener("change", onMq);
      else if (typeof mq.addListener === "function") mq.addListener(onMq);

      setOpenUi(false);
    });
  }

  function bindFacetPriceApply(root) {
    const scope = root || document;
    scope.querySelectorAll(".hrc-price-apply").forEach((btn) => {
      if (btn.dataset.hrcPriceApplyBound === "true") return;
      const form = btn.closest("form");
      if (!form) return;
      btn.dataset.hrcPriceApplyBound = "true";
      btn.addEventListener("click", () => {
        if (isFiltersDrawerOpen()) return;
        preparePriceInputs(form);
        queueFacetNavigation(function () {
          form.submit();
        });
      });
    });
  }

  function bindFacetFormAutoSubmit(root) {
    const scope = root || document;
    scope.querySelectorAll("facet-filters-form.hrc-facets-wrapper form").forEach((form) => {
      if (form.dataset.hrcFacetAutoSubmit === "true") return;
      form.dataset.hrcFacetAutoSubmit = "true";
      form.addEventListener("change", (e) => {
        const el = e.target;
        if (el.matches("[data-hrc-collection-sort]")) return;
        if (isFiltersDrawerOpen() && el.closest(".hrc-sidebar-filters")) return;
        if (
          el.matches(".hrc-facets-sort__select") ||
          el.matches(".hrc-checkbox-input")
        ) {
          queueFacetNavigation(function () {
            form.submit();
          });
        }
      });
    });
  }

  function bindCollectionSortSelect(root) {
    const scope = root || document;
    scope.querySelectorAll("[data-hrc-collection-sort]").forEach((select) => {
      if (select.dataset.hrcCollectionSortBound === "true") return;
      select.dataset.hrcCollectionSortBound = "true";
      select.addEventListener("change", () => {
        const raw = select.value;
        if (!raw) return;
        try {
          const target = new URL(raw, window.location.origin);
          const current = new URL(window.location.href);
          current.searchParams.forEach((value, key) => {
            if (key === "sort_by" || key === "page" || key === "hrc_page") return;
            if (key.startsWith("filter.") || key === "q" || key === "hrc_cat") {
              target.searchParams.append(key, value);
            }
          });
          queueFacetNavigation(function () {
            window.location.href = target.toString();
          });
        } catch {
          queueFacetNavigation(function () {
            window.location.href = raw;
          });
        }
      });
    });
  }

  function bindFilterResetRedirects(root) {
    const scope = root || document;
    scope.querySelectorAll("[data-hrc-filter-reset]").forEach((link) => {
      if (link.dataset.hrcFilterResetBound === "true") return;
      link.dataset.hrcFilterResetBound = "true";
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const href = link.href;
        queueFacetNavigation(function () {
          window.location.href = href;
        });
      });
    });
  }

  function bindShowMoreButtons(root) {
    const scope = root || document;
    scope.querySelectorAll(".hrc-btn-show-more").forEach((btn) => {
      if (btn.dataset.hrcShowMoreBound === "true") return;
      const block = btn.closest(".hrc-filter-block");
      const hiddenItems = block
        ? block.querySelectorAll(".hrc-filter-item--hidden")
        : [];
      if (!block || !hiddenItems.length) return;
      btn.dataset.hrcShowMoreBound = "true";

      const more = btn.querySelector(".hrc-btn-show-more__more");
      const less = btn.querySelector(".hrc-btn-show-more__less");

      btn.addEventListener("click", () => {
        const expanded = btn.classList.toggle("is-expanded");
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
        hiddenItems.forEach((li) => {
          if (expanded) li.classList.add("is-revealed");
          else li.classList.remove("is-revealed");
        });
        if (more && less) {
          more.hidden = expanded;
          less.hidden = !expanded;
        }
      });
    });
  }

  function init(root) {
    const r = root || document;
    bindFilterAccordions(r);
    bindFiltersDrawer(r);
    bindFacetFormAutoSubmit(r);
    bindCollectionSortSelect(r);
    bindFacetPriceApply(r);
    bindFilterResetRedirects(r);
    bindShowMoreButtons(r);
  }

  restoreFacetScroll();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
